import React, { FC } from "react";

import { Text } from "@epignosis_llc/gnosis";

import { FirstPlaceSVG, SecondPlaceSVG, ThirdPlaceSVG } from "@assets/images";

type RankingIconProps = {
  rankIndex: number;
};

const rankIcons = [FirstPlaceSVG, SecondPlaceSVG, ThirdPlaceSVG];

const RankingIcon: FC<RankingIconProps> = ({ rankIndex }) => {
  const Icon = rankIcons[rankIndex];

  return Icon ? (
    <Icon />
  ) : (
    <Text fontSize="md" weight="700">
      {rankIndex + 1}
    </Text>
  );
};

export default RankingIcon;
